import React, { Fragment, useEffect } from 'react';
import { alpha } from "@mui/material/styles";
import {makeStyles} from '@material-ui/core/styles';
import {AppBar, Typography,Toolbar, IconButton } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { sendMailTest } from '../../service/service.supersalud';


import "react-toastify/dist/ReactToastify.css";
import Image from "react-bootstrap/Image";
import Helmet from "react-helmet";
import {  FaSignOutAlt } from "react-icons/fa";
import logo from "./../../images/logo.png";
import imagen from './../../images/avatar.png';
import "./../templates/HeaderComponents/header.css";





const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    },
    color: "#FFFFFF"
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto"
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit"
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch"
    }
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  },
  sectionMobile: {
    display: "flex",
    marginTop: "10px",
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  }
}));
const AppSuperBar = props => {
 /*  const { user, userLogOut } = props; */
  const { user, userLogOut, wildcard, rut, userLoggedIn, type, searchNow, logout } = props;
  const classes = useStyles();
  const { innerWidth: width/*, innerHeight: height*/ } = window;

  const handleLogout = async () => {
    userLogOut();
  };
  

  useEffect(
    () => { },

    [user, userLogOut]
  );

  const sendMail = async () => {
    const resp = await sendMailTest(user, logout, userLoggedIn)(JSON.stringify({
      ...(rut && { rut }),
  }));

  const results = await resp.json()
  console.log(results)
  }

  return (
    /* <Fragment>
      <AppBar position="relative" className={classes.appBar}>
        <Toolbar>
          <img src={"/logo_super.png"} alt="Superintendencia de Salud" height="60" width="180" style={{ padding: 5 }} />
        </Toolbar>
      </AppBar>
      <AppBar position="static">
        <Toolbar>
          <Typography color="inherit" className={classes.textTitle}>
            Seguimiento de Trámites
          </Typography>
          {user && user.nombre ? <Fragment>
            <Typography color="inherit" className={classes.flex} />
            <IconButton
              color="inherit"
            >
              <AccountCircle />
              <Typography color="inherit"  className={classes.textTitle}>
                {user.nombre}
              </Typography>
             
            </IconButton>
            <IconButton onClick={handleLogout} color="inherit" >
              <ExitToAppOutlinedIcon />
              <Typography color="inherit" className={classes.textTitle} >
                Salir
              </Typography>
            </IconButton>
          </Fragment>
            :
            <Fragment>
              <Typography color="inherit" className={classes.flex} />
              <IconButton onClick={handleInicio} color="inherit" >
                <HomeIcon className={classes.iconInicio} />
                <Typography color="inherit"  className={classes.textTitle}>
                  Inicio
                </Typography>
              
            </IconButton>
            </Fragment>
          }
        </Toolbar>
      </AppBar>
    </Fragment> */




    <>
    <Helmet>
      <title>Seguimiento de Trámites</title>
      <meta name="description" content={"Superintendencia de Salud"} />
    </Helmet>

    <header className="d-flex header-resposive-ss">

      <Image src={logo} className="logo-responsive" />
      
    </header>

      {user && user.nombre ?  width > 770 ?
      
      <div className="personal-info-ss contenedor mt-5">
      
      <div>
      <h1 style={{fontSize: 24, fontWeight: "bold",textAlign:"left",margin:"0px"}} className="my-auto">Seguimiento de Trámites</h1>
      {/* <h1 style={{fontSize: 24, fontWeight: "bold",textAlign:"left",margin:"0px"}} className="my-auto">Bienvenido/a {user && user.nombre ? " " + user.nombre  : null}.</h1>
      <h1 className="py-0" style={{fontSize: 24, fontWeight: "bold",textAlign:"left",margin:"0px"}}> Accede tus trámites disponibles.</h1>*/}
      </div>

        <div className="perfil-ss">
          {/* <img src={imagen} alt="Imagen de Perfil" className="image-header-ss" onClick={()=>{sendMail()}}/> */}
          <img src={imagen} alt="Imagen de Perfil" className="image-header-ss"/> 

          <div className="usuario-ss px-3">
            <p className="my-0" style={{fontSize: 14, fontWeight: "bold",padding:"3px"}}>{user && user.nombre  ? user.nombre  : null}</p>
            {/* <p className="my-0" style={{fontSize: 12, fontWeight: "normal", color: "#0073ba", cursor: "pointer"}}>Editar Perfil <FaUserEdit/></p> */}
          </div>

          <div className="bar-perfil-ss"></div>
         
          <div onClick={() => handleLogout()} >
            <p className="my-0 faq-perfil-ss  text-center" style={{ cursor: "pointer"}}>Cerrar Sesión <FaSignOutAlt /></p> 
          </div>

          {/* <div className="faq-perfil-icon">
           <FaSignOutAlt style={{fontSize: 16, fontWeight: "normal", color: "#0073ba"}}/>
          </div> */}
        </div>
    </div>
    :<div className={classes.grow}>
    <AppBar position="static">
      <Toolbar>
       
       
       
          
          <Typography className={classes.title} variant="h6" noWrap>
          Seguimiento de trámites
        </Typography>
         
          
        
        <div className={classes.grow} />
        
        <div className={classes.sectionMobile}>
          <IconButton
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
            size="large">
            <AccountCircle />
          </IconButton>
          <p onClick={() => handleLogout()} style={{marginTop:"10px"}} ><b>Cerrar session</b></p>
        </div>
      </Toolbar>
    </AppBar>
    
  </div>:null}
      {/* HEADER RESPONSIVE */}

  </>
  );
}

export default AppSuperBar;


